module.exports = "/assets/images/angry.png";